import { BackButton } from '@/components';
import { EventsTabSkeleton } from '@/features/DirectoryItemPage';

export function VehiclePageSkeleton() {
    return (
        <div className="h-full relative">
            <BackButton variant="floating" />

            <div className="relative h-full min-h-0 flex flex-col items-center">
                <div className="absolute top-6 left-1/2 -translate-x-1/2 z-40">
                    <div className="h-10 min-w-[120px] rounded-full skeleton-item-container" />
                </div>

                <div className="w-full flex-1 min-h-0">
                    <div className="h-full flex flex-col relative overflow-hidden pt-14">
                        <div className="flex-1 flex overflow-y-auto scrollbar-hide px-4">
                            <div className="flex-1 flex flex-col gap-6 pt-8 pb-24 min-w-0 max-w-content mx-auto">
                                <div className="relative w-full rounded-lg overflow-hidden h-[118px] skeleton-item-container">
                                    <div className="relative h-full flex items-center px-6 gap-4">
                                        <div
                                            className="w-[70px] h-[70px] shrink-0 rounded-full bg-grey-800 opacity-0"
                                            aria-hidden
                                        />
                                        <div className="flex flex-col gap-1.5 min-w-0">
                                            <div className="flex items-center gap-2.5">
                                                <div
                                                    className="h-5 w-40 shrink-0 opacity-0"
                                                    aria-hidden
                                                />
                                                <div
                                                    className="h-6 w-24 shrink-0 opacity-0"
                                                    aria-hidden
                                                />
                                            </div>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <div
                                                    className="h-5 w-16 shrink-0 opacity-0"
                                                    aria-hidden
                                                />
                                                <div
                                                    className="h-5 w-20 shrink-0 opacity-0"
                                                    aria-hidden
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="absolute right-6 bottom-8 h-9 w-36 opacity-0"
                                            aria-hidden
                                        />
                                    </div>
                                </div>

                                <div className="flex items-center gap-1">
                                    <div
                                        className="h-7 w-16 shrink-0 opacity-0"
                                        aria-hidden
                                    />
                                    <div
                                        className="h-7 w-20 shrink-0 opacity-0"
                                        aria-hidden
                                    />
                                </div>

                                <EventsTabSkeleton />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
